import React from 'react';
import { lazy } from 'react-loosely-lazy';
import { useIntl } from '@atlassian/jira-intl';
import Placeholder from '@atlassian/jira-placeholder';
import { type SortIssuesDropdown, SortOrderIcon, StyledButton } from './sorting-dropdown';
import messages from './sorting-dropdown/messages';

import { useCurrentSortOptions } from './sorting-dropdown/utils';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazySortIssues = lazy<typeof SortIssuesDropdown>(() =>
	import(
		/* webpackChunkName: "async-version-detail-sort-issues" */ './sorting-dropdown/index'
	).then((module) => module.SortIssuesDropdown),
);

export const AsyncSortIssues = () => {
	const { formatMessage } = useIntl();

	const { currentSortByOption, currentSortOrderOption } = useCurrentSortOptions();

	return (
		<Placeholder
			name="version-detail-sort-issues"
			fallback={
				<StyledButton iconAfter={<SortOrderIcon order={currentSortOrderOption.id} />}>
					{`${formatMessage(messages.sortBy)}: ${formatMessage(currentSortByOption.label)}`}
				</StyledButton>
			}
		>
			<LazySortIssues />
		</Placeholder>
	);
};
